/**
 * concepts.js
 *
 * Full restaurant concept data for the Chamcore AutoSite restaurant template.
 * Ported from the production restaurant app (restaurant.zip).
 *
 * The frontend merges these defaults with the site-specific config returned by
 * site-config.php (branding.company_name, content.about, etc.) so the customer's
 * own text and logo override the demo placeholders.
 *
 * To add a new concept: add a key here and map it in autosite-builder.html's
 * conceptForTemplate() helper.
 */

export const CONCEPTS = {

  // ─────────────────────────────────────────────────────────────────
  // THAI
  // ─────────────────────────────────────────────────────────────────
  thai: {
    key: 'thai',
    theme: {
      chili: '#e23b2e',
      herb:  '#1f7a52',
      gold:  '#e8a13a',
      bg:    '#fbf6ee',
      ink:   '#1c1a17',
      line:  '#ece3d6',
    },
    restaurant: {
      name:        'Thai Restaurant',
      address:     'Din adresse, Oslo',
      phone:       '+47 00 00 00 00',
      hours:       'Man–søn 14:00–22:00',
      etaMinutes:  20,
      rating:      4.8,
      reviews:     320,
      heroMode:    'slider',
      heroZoom:    true,
      heroImages: [
        'photo-1559314809-0d155014e29e',
        'photo-1455619452474-d2be8b1e70cd',
        'photo-1604908176997-125f25cc6f3d',
      ],
      delivery: {
        enabled:    true,
        provider:   'wolt',
        fee:        59,
        freeOver:   599,
        minOrder:   149,
        etaMinutes: 40,
      },
      social: {
        instagram: 'https://instagram.com',
        facebook:  'https://facebook.com',
        tiktok:    'https://tiktok.com',
      },
    },
    heroH1:    'Ekte thaimat, klar til henting.',
    socialLead:'Følg oss for nye retter og ukens tilbud. Tagg maten din med',
    hashtag:   '#ThaiRestaurant',
    cats: [
      { id: 'forretter', name: 'Forretter' },
      { id: 'wok',       name: 'Wok & Nudler' },
      { id: 'curry',     name: 'Curry' },
      { id: 'ris',       name: 'Ris & Grill' },
      { id: 'dessert',   name: 'Dessert' },
      { id: 'drikke',    name: 'Drikke' },
    ],
    menu: [
      { id:'f1', cat:'forretter', name:'Sprø vårruller',       price:89,  spicy:0, available:true, tags:['Vegetar'],  img:'photo-1548811256-1627d99057a2', desc:'Fire stk med grønnsaker, servert med sweet chili.',         alg:['Gluten','Soya'],              sku:'1001' },
      { id:'f2', cat:'forretter', name:'Thai fiskekaker',      price:99,  spicy:1, available:true, tags:[],           img:'photo-1625938145744-e380515399b7', desc:'Tod mun pla med agurkrelish og peanøtter.',              alg:['Fisk','Egg'],                 sku:'1002' },
      { id:'f3', cat:'forretter', name:'Satay kyllingspyd',    price:109, spicy:0, available:true, tags:['Populær'], img:'photo-1529563021893-cc83c992d75d', desc:'Marinerte spyd grillet, med peanøttsaus.',               alg:['Peanøtter','Soya'],           sku:'1003' },
      { id:'f4', cat:'forretter', name:'Tom Yum suppe',        price:119, spicy:2, available:true, tags:[],           img:'photo-1547928576-b822bc410bdf', desc:'Syrlig-sterk suppe med sitrongress, lime og scampi.',     alg:['Skalldyr','Fisk'],            sku:'1004' },
      { id:'w1', cat:'wok',       name:'Pad Thai kylling',     price:189, spicy:1, available:true, tags:['Populær'], img:'photo-1559314809-0d155014e29e', desc:'Risnudler wokket med egg, vårløk, tamarind og peanøtter.', alg:['Peanøtter','Egg','Soya','Fisk'], sku:'1005' },
      { id:'w2', cat:'wok',       name:'Pad Thai scampi',      price:219, spicy:1, available:true, tags:[],           img:'photo-1637806930600-37fa8892069d', desc:'Klassisk Pad Thai med saftige scampi.',                  alg:['Skalldyr','Peanøtter','Egg'],  sku:'1006' },
      { id:'w3', cat:'wok',       name:'Pad See Ew biff',      price:199, spicy:1, available:true, tags:[],           img:'photo-1626804475297-41608ea09aeb', desc:'Brede risnudler i søt soya med biff og brokkoli.',       alg:['Soya','Gluten','Egg'],         sku:'1007' },
      { id:'w4', cat:'wok',       name:'Drunken Noodles',      price:199, spicy:3, available:true, tags:[],           img:'photo-1645696301019-35adcc18fc21', desc:'Pad Kee Mao — sterke nudler med basilikum og chili.',    alg:['Soya','Fisk'],                sku:'1008' },
      { id:'c1', cat:'curry',     name:'Grønn curry kylling',  price:199, spicy:2, available:true, tags:['Populær'], img:'photo-1455619452474-d2be8b1e70cd', desc:'Kremet kokoscurry med bambus, basilikum og aubergine.',   alg:['Fisk'],                       sku:'1009' },
      { id:'c2', cat:'curry',     name:'Rød curry biff',       price:209, spicy:2, available:true, tags:[],           img:'photo-1604908176997-125f25cc6f3d', desc:'Fyldig rød curry med kokosmelk og paprika.',             alg:['Fisk'],                       sku:'1010' },
      { id:'c3', cat:'curry',     name:'Massaman curry',       price:215, spicy:1, available:true, tags:[],           img:'photo-1574484284002-952d92456975', desc:'Mild, nøtteaktig curry med potet og peanøtter.',         alg:['Peanøtter','Fisk'],           sku:'1011' },
      { id:'c4', cat:'curry',     name:'Panang scampi',        price:229, spicy:2, available:true, tags:[],           img:'photo-1569562211093-4ed0d0758f12', desc:'Tykk, aromatisk panang med kaffirlime og scampi.',       alg:['Skalldyr','Peanøtter','Fisk'], sku:'1012' },
      { id:'r1', cat:'ris',       name:'Stekt ris med kylling',price:179, spicy:0, available:true, tags:[],           img:'photo-1603133872878-684f208fb84b', desc:'Khao pad med egg, løk, tomat og vårløk.',               alg:['Egg','Soya'],                 sku:'1013' },
      { id:'r2', cat:'ris',       name:'Thai BBQ kyllingspyd', price:189, spicy:1, available:true, tags:['Populær'], img:'photo-1432139555190-58524dae6a55', desc:'Grillet gai yang med jasminris og dippsaus.',            alg:['Soya','Sesam'],               sku:'1014' },
      { id:'r3', cat:'ris',       name:'Basilikumkylling m/ ris',price:189,spicy:3,available:true, tags:[],           img:'photo-1512058564366-18510be2db19', desc:'Pad krapow gai med stekt egg på toppen.',               alg:['Soya','Egg','Fisk'],          sku:'1015' },
      { id:'d1', cat:'dessert',   name:'Mango sticky rice',    price:99,  spicy:0, available:true, tags:['Vegetar'],  img:'photo-1711161054754-f4cabaf16fc2', desc:'Søt klebrig ris med fersk mango og kokoskrem.',          alg:[],                             sku:'1016' },
      { id:'d2', cat:'dessert',   name:'Friterte bananer',     price:89,  spicy:0, available:true, tags:[],           img:'photo-1606313564200-e75d5e30476c', desc:'Sprø bananer med vaniljeis og honning.',                 alg:['Gluten','Melk','Egg'],        sku:'1017' },
      { id:'b1', cat:'drikke',    name:'Thai iste',            price:49,  spicy:0, available:true, tags:[],           img:'photo-1558857563-b371033873b8', desc:'Søt, kremet iste med kondensert melk.',                    alg:['Melk'],                       sku:'1018' },
      { id:'b2', cat:'drikke',    name:'Singha øl',            price:79,  spicy:0, available:true, tags:[],           img:'photo-1608270586620-248524c67de9', desc:'Iskald thailandsk pils, 0,33 l.',                       alg:['Gluten'],                     sku:'1019' },
      { id:'b3', cat:'drikke',    name:'Brus',                 price:39,  spicy:0, available:true, tags:[],           img:'photo-1622483767028-3f66f32aef97', desc:'Coca-Cola, Cola Zero, Sprite eller Fanta.',             alg:[],                             sku:'1020' },
    ],
  },

  // ─────────────────────────────────────────────────────────────────
  // PIZZA
  // ─────────────────────────────────────────────────────────────────
  pizza: {
    key: 'pizza',
    theme: {
      chili: '#c8102e',
      herb:  '#2e7d32',
      gold:  '#e0a23a',
      bg:    '#fbf4e9',
      ink:   '#241a12',
      line:  '#ece0cf',
    },
    restaurant: {
      name:        'Pizza Restaurant',
      address:     'Din adresse, Oslo',
      phone:       '+47 00 00 00 00',
      hours:       'Man–søn 14:00–23:00',
      etaMinutes:  25,
      rating:      4.7,
      reviews:     280,
      heroMode:    'slider',
      heroZoom:    true,
      heroImages: [
        'photo-1513104890138-7c749659a591',
        'photo-1604382354936-07c5d9983bd3',
        'photo-1571066811602-716837d681de',
      ],
      delivery: {
        enabled:    true,
        provider:   'wolt',
        fee:        69,
        freeOver:   549,
        minOrder:   159,
        etaMinutes: 45,
      },
      social: {
        instagram: 'https://instagram.com',
        facebook:  'https://facebook.com',
        tiktok:    'https://tiktok.com',
      },
    },
    heroH1:    'Ekte italiensk pizza, rett fra ovnen.',
    socialLead:'Følg oss for nye retter og ukens tilbud. Tagg maten din med',
    hashtag:   '#PizzaRestaurant',
    cats: [
      { id: 'pizza',    name: 'Pizza' },
      { id: 'antipasti',name: 'Antipasti' },
      { id: 'pasta',    name: 'Pasta' },
      { id: 'dolci',    name: 'Dessert' },
      { id: 'drikke',   name: 'Drikke' },
    ],
    menu: [
      { id:'p1',  cat:'pizza',    name:'Margherita',            price:169, spicy:0, available:true, tags:['Vegetar'],  img:'photo-1604382354936-07c5d9983bd3', desc:'Tomat, mozzarella og fersk basilikum.',                  alg:['Gluten','Melk'],      sku:'1001' },
      { id:'p2',  cat:'pizza',    name:'Marinara',              price:159, spicy:0, available:true, tags:['Vegan'],    img:'photo-1571066811602-716837d681de', desc:'Tomat, hvitløk, oregano og olivenolje.',                 alg:['Gluten'],             sku:'1002' },
      { id:'p3',  cat:'pizza',    name:'Pepperoni',             price:189, spicy:1, available:true, tags:['Populær'], img:'photo-1628840042765-356cda07504e', desc:'Tomat, mozzarella og pepperoni.',                        alg:['Gluten','Melk'],      sku:'1003' },
      { id:'p4',  cat:'pizza',    name:'Quattro Formaggi',      price:209, spicy:0, available:true, tags:['Vegetar'],  img:'photo-1513104890138-7c749659a591', desc:'Fire italienske oster.',                                alg:['Gluten','Melk'],      sku:'1004' },
      { id:'p5',  cat:'pizza',    name:'Prosciutto e Funghi',   price:199, spicy:0, available:true, tags:[],           img:'photo-1565299624946-b28f40a0ae38', desc:'Skinke og sjampinjong.',                                alg:['Gluten','Melk'],      sku:'1005' },
      { id:'p6',  cat:'pizza',    name:'Diavola',               price:199, spicy:3, available:true, tags:['Sterk'],   img:'photo-1593560708920-61dd98c46a4e', desc:'Sterk salami og chili.',                                alg:['Gluten','Melk'],      sku:'1006' },
      { id:'p7',  cat:'pizza',    name:'Vegetariana',           price:189, spicy:0, available:true, tags:['Vegetar'],  img:'photo-1574071318508-1cdbab80d002', desc:'Grillede grønnsaker.',                                  alg:['Gluten','Melk'],      sku:'1007' },
      { id:'p8',  cat:'pizza',    name:'Calzone',               price:199, spicy:0, available:true, tags:[],           img:'photo-1536964549204-cce9eab227bd', desc:'Innbakt pizza med skinke og ricotta.',                  alg:['Gluten','Melk'],      sku:'1008' },
      { id:'a1',  cat:'antipasti',name:'Hvitløksbrød',          price:79,  spicy:0, available:true, tags:['Vegetar'],  img:'photo-1573140247632-f8fd74997d5c', desc:'Sprøtt brød med hvitløkssmør.',                         alg:['Gluten','Melk'],      sku:'1009' },
      { id:'a2',  cat:'antipasti',name:'Bruschetta',            price:89,  spicy:0, available:true, tags:['Vegetar'],  img:'photo-1572695157366-5e585ab2b69f', desc:'Ristet brød med tomat og basilikum.',                   alg:['Gluten'],             sku:'1010' },
      { id:'a3',  cat:'antipasti',name:'Caprese-salat',         price:119, spicy:0, available:true, tags:['Vegetar'],  img:'photo-1608897013039-887f21d8c804', desc:'Mozzarella, tomat og basilikum.',                       alg:['Melk'],               sku:'1011' },
      { id:'pa1', cat:'pasta',    name:'Spaghetti Bolognese',   price:179, spicy:0, available:true, tags:[],           img:'photo-1622973536968-3ead9e780960', desc:'Kjøttsaus på spaghetti.',                               alg:['Gluten'],             sku:'1012' },
      { id:'pa2', cat:'pasta',    name:'Carbonara',             price:189, spicy:0, available:true, tags:['Populær'], img:'photo-1612874742237-6526221588e3', desc:'Egg, pancetta og parmesan.',                             alg:['Gluten','Egg','Melk'], sku:'1013' },
      { id:'pa3', cat:'pasta',    name:'Lasagne',               price:199, spicy:0, available:true, tags:[],           img:'photo-1574894709920-11b28e7367e3', desc:'Ovnsbakt med kjøtt og bechamel.',                       alg:['Gluten','Melk','Egg'], sku:'1014' },
      { id:'pa4', cat:'pasta',    name:'Penne Arrabbiata',      price:169, spicy:2, available:true, tags:['Vegetar','Sterk'], img:'photo-1563379926898-05f4575a45d8', desc:'Tomat og chili.',                               alg:['Gluten'],             sku:'1015' },
      { id:'d1',  cat:'dolci',    name:'Tiramisu',              price:89,  spicy:0, available:true, tags:[],           img:'photo-1571877227200-a0d98ea607e9', desc:'Klassisk italiensk dessert.',                           alg:['Gluten','Melk','Egg'], sku:'1016' },
      { id:'d2',  cat:'dolci',    name:'Panna Cotta',           price:85,  spicy:0, available:true, tags:[],           img:'photo-1488477181946-6428a0291777', desc:'Med bærcoulis.',                                        alg:['Melk'],               sku:'1017' },
      { id:'b1',  cat:'drikke',   name:'San Pellegrino',        price:45,  spicy:0, available:true, tags:[],           img:'photo-1605948711711-1e5e9a4a8e0e', desc:'Italiensk mineralvann, 0,33 l.',                        alg:[],                     sku:'1018' },
      { id:'b2',  cat:'drikke',   name:'Peroni',                price:79,  spicy:0, available:true, tags:[],           img:'photo-1608270586620-248524c67de9', desc:'Italiensk lagerøl, 0,33 l.',                            alg:['Gluten'],             sku:'1019' },
      { id:'b3',  cat:'drikke',   name:'Brus',                  price:39,  spicy:0, available:true, tags:[],           img:'photo-1622483767028-3f66f32aef97', desc:'Coca-Cola, Fanta eller Sprite.',                        alg:[],                     sku:'1020' },
      { id:'b4',  cat:'drikke',   name:'Espresso',              price:35,  spicy:0, available:true, tags:[],           img:'photo-1510707577719-ae7c14805e3a', desc:'Ekte italiensk espresso.',                              alg:[],                     sku:'1021' },
    ],
  },
};

/**
 * Resolve a CONCEPT from a concept_key string.
 * Falls back to Thai if key is unknown.
 */
export function getConcept(key) {
  return CONCEPTS[key] || CONCEPTS.thai;
}

/**
 * Build a fully-merged restaurant data object by overlaying the site's
 * branding/content/restaurant_config on top of the concept defaults.
 *
 * @param {object} concept   – one of CONCEPTS.thai / CONCEPTS.pizza
 * @param {object} config    – the site config from site-config.php
 * @returns {object}         – { concept, restaurant, theme, h1, heroSub, about, email, logo }
 */
export function buildRestaurantData(concept, config) {
  const rc = config.restaurant_config || {};
  const b  = config.branding          || {};
  const c  = config.content           || {};

  const restaurant = {
    ...concept.restaurant,
    name:    b.company_name || rc.name    || concept.restaurant.name,
    phone:   c.contact_phone || rc.phone  || concept.restaurant.phone,
    address: c.address       || rc.address|| concept.restaurant.address,
  };

  const theme = {
    ...concept.theme,
    chili: b.primary || rc.primary || concept.theme.chili,
  };

  return {
    concept,
    restaurant,
    theme,
    logo:     b.logo_url || rc.logo_url || null,
    h1:       c.hero_headline || rc.hero_headline || concept.heroH1,
    heroSub:  c.hero_sub      || rc.hero_sub      || '',
    about:    c.about         || rc.about         || '',
    email:    c.contact_email || rc.email         || '',
    menu:     concept.menu,
    cats:     concept.cats,
  };
}
